module.exports = __webpack_public_path__ + "img/logo_cn.5a3acdbe.png";